<!-- app/components/Auth/index.vue -->
<template>
  <div id="login" class="hidden" aria-hidden="true"></div>
  <div id="register" class="hidden" aria-hidden="true"></div>
  <ClientOnly>
    <UModal title="+IFMG" :fullscreen="isMobile" v-model:open="uiStore.isAuthModalOpen" close-icon="ph:x"
            :ui="{
            overlay: 'bg-black/80',
            content: 'sm:max-w-fit lg:min-w-[900px] !max-h-[96vh] overflow-y-auto',
            title: 'text-xl font-bold',
            body: 'sm:p-3 p-3 overflow-y-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:display-none',
            footer: 'p-2',}">

      <template #body>
        <div class="text-lg">
          <UTabs v-model="activeTab" :items="tabs" variant="link" :ui="{ trigger: 'grow' }" size="md" class="w-full">

            <template #login>
              <AuthLogin />
            </template>

            <template #register>
              <AuthRegister />
            </template>
          </UTabs>
        </div>
      </template>
    </UModal>
  </ClientOnly>
</template>

<script setup lang="ts">
import { useBreakpoints, breakpointsTailwind } from '@vueuse/core'
import type { TabsItem } from '@nuxt/ui'
import { computed } from 'vue'

defineOptions({
  name: 'AuthModal'
})

const props = defineProps<{ textClass?: string }>()

const uiStore = useUiStore()
const userStore = useUserStore()
const route = useRoute()
const router = useRouter()

const breakpoints = useBreakpoints(breakpointsTailwind)
const isMobile = breakpoints.smaller('sm')

const tabs = [
    { label: 'Login', slot: 'login', value: 'login'},
    { label: 'Cadastro', slot: 'register', value: 'register'}
] satisfies TabsItem[]

watch(() => uiStore.isAuthModalOpen, async (isOpen) => {
  if (!isOpen) {
    // Limpar o hash da URL quando o modal for fechado para que se o usuário abrir de novo sem hash, não fique preso no estado anterior
    if (route.hash) router.replace({hash: ''});
  }
})

const activeTab = computed({
  get() {
    // Lê o hash da URL (ex: '#register') e remove o '#'.
    // Se não for um dos valores válidos, o padrão é 'login'.
    const currentHash = route.hash.replace('#', '')
    return currentHash === 'register' ? 'register' : 'login'
  },
  set(value: string) {
    // Quando o usuário clica em uma nova aba no UTabs, este setter é acionado.
    // Atualizamos a URL com o novo hash.
    router.replace({hash: `#${value}`})
  }
})

// Monitora a URL para abrir o modal no momento certo
watch(
    () => route.hash,
    (newHash) => {
      if (newHash === '#login' || newHash === '#register') {
        uiStore.closeForgotModal();
        uiStore.openAuthModal();
      } else if (newHash === '#forgot_password') {
        uiStore.closeAuthModal();
        uiStore.openForgotModal();
      }
    },
    {immediate: true} // Avalia a URL assim que o componente é criado
)

// Faz o redirecionamento caso o usuário caia aqui já logado
onMounted(async () => {
  // Verificamos se não há hash de auth na URL e se o usuário está logado
  if (route.hash !== '#login' && route.hash !== '#register') {
    if (userStore.isLoggedIn && userStore.isLogging) {
      // fecha o modal caso o usuário tenha logado com sucesso e redireciona para o Painel do Moodle.
      uiStore.isAuthModalOpen = false
      userStore.isLogging = false;
      // O 'replace: true' garante que a página não fique no histórico de "Voltar" do navegador
      await navigateTo('/my/', {external: true, replace: true})
    }
  }
})
</script>